import superagent from 'superagent';
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';

export const login = createAsyncThunk(
	'user/loginLoading',
	(options, {getState}) =>
		superagent
			.post(`${getState().status.authUrl}/auth.php`)
			.send(options)
			.set('Accept', 'application/json')
			.then((response) => response.body)
			.catch((error) => error)
);
export const silentLogin = createAsyncThunk(
	'user/silentLoginLoading',
	(options, {getState}) =>
		superagent
			.get(`${getState().status.authUrl}/auth.php`)
			.set('Accept', 'application/json')
			.then((response) => response.body)
			.catch((error) => error)
);
export const logout = createAsyncThunk(
	'user/logout',
	(options, {getState}) =>
		superagent
			.get(`${getState().status.authUrl}/logout.php`)
			.set('Accept', 'application/json')
			.then((response) => response.body)
			.catch((error) => error)
);
const userInitialState = {
	status: 'idle',
	data: {
		loggedIn: false,
		loginFailed: false,
		lightprofile_config_download: false,
		lightprofile_config_upload: false,
		lightprofile_edit_dimmlevel: false,
		lightprofile_custom_profile: false,
		aeto_internal: false,
		message: '',
		userId: '',
		userName: '',
	},
	error: {},
};
export const userSlice = createSlice({
	name: 'user',
	initialState: userInitialState,
	reducers: {
		setLoggedIn: (state, action) => {
			state.data.loggedIn = action.payload.loggedIn;
		}
	},
	extraReducers: (builder) => {
		builder.addCase(login.fulfilled, (state, action) => {
			const success = action.payload.message === 'LOGIN_SUCCESSFUL';
			if (success) {
				state.data = action.payload;
				state.data.loggedIn = true;
				state.data.loginFailed = false;
			} else {
				state.data.loggedIn = false;
				state.data.loginFailed = true;
				state.error = action.payload.response.body;
			}
			state.status = 'idle';
		});
		builder.addCase(login.pending, (state, action) => {
			state.status = 'loading';
			state.error = {};
		});
		builder.addCase(login.rejected, (state, action) => {
			state.data = userInitialState;
			state.status = 'idle';
			state.error = action.payload;
		});
		builder.addCase(silentLogin.fulfilled, (state, action) => {
			state.data = action.payload;
			state.data.loggedIn = action.payload.message === 'LOGIN_SUCCESSFUL';
			state.status = 'idle';
			state.error = {};
		});
		builder.addCase(silentLogin.pending, (state, action) => {
			state.status = 'loading';
			state.error = {};
		});
		builder.addCase(silentLogin.rejected, (state, action) => {
			state.data = {};
			state.status = 'idle';
			state.error = action.payload;
		});
		builder.addCase(logout.fulfilled, (state, action) => {
			state.data = userInitialState;
			state.status = 'idle';
			state.error = {};
		});
		builder.addCase(logout.pending, (state, action) => {
			state.status = 'loading';
			state.error = {};
		});
		builder.addCase(logout.rejected, (state, action) => {
			state.data = {};
			state.status = 'idle';
			state.error = action.payload;
		});
	}
});


export const {
	setLoggedIn,
} = userSlice.actions;


export default userSlice.reducer;
